import { AdminComponent } from '~/components/admin-component/admin-component';

export const CallCategories = () => (
  <AdminComponent
    componentName="CallLogCategories"
    title="Call Log Categories"
  />
);
